<div style="width: 20%">
  <div class="text-muted small mb-1">{{ 'pages.channels.view.rule.code' | translate }}</div>
  <div class="fw-semibold text-dark text-truncate-custom">{{ rule!.code }}</div>
</div>
<div style="width: 60%">
  <div class="text-muted small mb-1">{{ 'pages.channels.view.rule.description' | translate }}</div>
  <div class="fw-semibold text-truncate-custom">{{ rule!.description }}</div>
</div>
<div style="width: 15%">
  <div class="text-muted small mb-1">{{ 'pages.channels.view.rule.action' | translate }}</div>
  <div class="action-label">{{ rule!.action }}</div>
</div>
<div style="width: 5%">
  <div class="text-muted small mb-1">{{ 'pages.channels.view.rule.value' | translate }}</div>
  <div class="weight-label">{{ rule!.value?.toFixed(1) }}</div>
</div>
